module.exports = __webpack_public_path__ + "static/media/strop.6af5ccab.jpg";